const USER_DATA = [
    {
        id: 0,
        firstName: `Cong`,
        lastName: `Liu`,
        date: `2019-07-21`,
        location: `China`,
        interests: [`basketball`, `swimming`, `public speaking`]
    }
];

export default USER_DATA;
